import { 
  createFieldChange, 
  createAuditLogData
} from '../../utils/historyUtils';

/**
 * Service for managing labor targets
 * Copied from locationAdminService.js with minimal changes
 */
class LaborService {
  // Update location labor targets
  async updateLocationLaborTargets(locationId, updates, userId, userName, clientId) {
    try {
      // Build field changes for audit log
      const fieldChanges = [];
      
      // Check FOH Base Hours changes
      if (updates.previousTargets?.fohBaseHours && updates.currentTargets?.fohBaseHours) {
        const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        for (const day of days) {
          const oldValue = updates.previousTargets.fohBaseHours[day];
          const newValue = updates.currentTargets.fohBaseHours[day];
          if (oldValue !== newValue) {
            fieldChanges.push(createFieldChange(
              `FOH Base Hours (${day})`,
              oldValue,
              newValue,
              'number'
            ));
          }
        }
      }
      
      // Check BOH Base Hours changes
      if (updates.previousTargets?.bohBaseHours && updates.currentTargets?.bohBaseHours) {
        const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        for (const day of days) {
          const oldValue = updates.previousTargets.bohBaseHours[day];
          const newValue = updates.currentTargets.bohBaseHours[day];
          if (oldValue !== newValue) {
            fieldChanges.push(createFieldChange(
              `BOH Base Hours (${day})`,
              oldValue,
              newValue,
              'number'
            ));
          }
        }
      }
      
      // Check FOH SPLH Targets changes
      if (updates.previousTargets?.fohSplhTargets && updates.currentTargets?.fohSplhTargets) {
        const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        for (const day of days) {
          const oldValue = updates.previousTargets.fohSplhTargets[day];
          const newValue = updates.currentTargets.fohSplhTargets[day];
          if (oldValue !== newValue) {
            fieldChanges.push(createFieldChange(
              `FOH SPLH Target (${day})`,
              oldValue,
              newValue,
              'number'
            ));
          }
        }
      }
      
      // Check BOH SPLH Targets changes
      if (updates.previousTargets?.bohSplhTargets && updates.currentTargets?.bohSplhTargets) {
        const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        for (const day of days) {
          const oldValue = updates.previousTargets.bohSplhTargets[day];
          const newValue = updates.currentTargets.bohSplhTargets[day];
          if (oldValue !== newValue) {
            fieldChanges.push(createFieldChange(
              `BOH SPLH Target (${day})`,
              oldValue,
              newValue,
              'number'
            ));
          }
        }
      }

      // Only create audit log if there are actual changes
      if (fieldChanges.length > 0) {
        const auditData = createAuditLogData({
          clientId: clientId,
          changeType: 'LABOR_UPDATE',
          entityType: 'LocationLaborTargets',  // Changed to LocationLaborTargets
          entityId: locationId,
          entityName: updates.locationName || `Location ${locationId}`,
          section: 'Labor & Targets',
          fieldChanges: fieldChanges,
          changeReason: updates.reason || 'Labor targets updated',
          userId: userId,
          userName: userName
        });

        await this.createAuditLog(auditData);

      } else {
      }

      return { success: true, changeCount: fieldChanges.length };
    } catch (error) {
      console.error('❌ Error updating location labor targets:', error);
      throw error;
    }
  }

  // Format labor target change for display
  formatLaborTargetChange(entry) {
    const reasonTypeMap = {
      'INITIAL_SETUP': 'Initial setup',
      'ADJUSTMENT': 'Manual adjustment',
      'SEASONAL': 'Seasonal adjustment',
      'PERFORMANCE': 'Performance-based adjustment',
      'OTHER': 'Other change'
    };
    
    const reasonText = reasonTypeMap[entry.reasonType] || entry.reasonType || 'Updated';
    return `${reasonText}${entry.reason ? `: ${entry.reason}` : ''}`;
  }

  // Use the historyService for audit logging
  async createAuditLog(logData) {
    const { default: historyService } = await import('./historyService');
    return historyService.createAuditLog(logData);
  }
}

export default new LaborService();